export enum BackgroundImageType {
  PLAYER = 'PLAYER',
  STRUCTURE = 'STRUCTURE',
}
